import { MRT_ColumnFiltersState } from 'mantine-react-table'
import { formatDateForSending } from '@/shared/lib/utils'

export const useTableFilters = (columnFilters: MRT_ColumnFiltersState) => {
  const getBoolean = (filterId: string): boolean | undefined => {
    const filterValue = columnFilters.find(f => f.id === filterId)?.value as string | undefined
    if (filterValue === 'true') return true
    if (filterValue === 'false') return false
    return undefined
  }

  const getMultiSelectIds = (filterId: string): number[] => {
    return (columnFilters.find(f => f.id === filterId)?.value ?? []) as number[]
  }

  const getDateRange = (filterId: string): (string | null)[] | undefined => {
    const dateFilter = columnFilters.find(f => f.id === filterId)
    const dateValue = dateFilter?.value as Date[]
    return dateValue?.map((d: Date, i) =>
      i === 0 ? formatDateForSending(d, 'start') : formatDateForSending(d, 'end'),
    )
  }

  const getTextFilter = (filterId: string): string | undefined => {
    const filterValue = columnFilters.find(f => f.id === filterId)?.value as string | undefined
    return filterValue || undefined
  }

  return {
    getBoolean,
    getMultiSelectIds,
    getDateRange,
    getTextFilter,
  }
}
